import gsap from 'gsap';

function initGLFImageShareReveal() {
    const images = document.querySelectorAll('.largeGraphicSection, .largeGraphicSectionDark');
    for (const image of images) {
        image.addEventListener('mouseenter', function (event) {
            revealToolbar(event.target)
        })

        image.addEventListener('mouseleave', function (event) {
            hideToolbar(event.target)
        })
    }

    function revealToolbar(target) {
        const image = target.querySelector('img');
        image.classList.add('blurImage');
        const toolbar = target.querySelector('.hiddenToolBar');
        gsap.set(toolbar, { autoAlpha: 1 });
        gsap.fromTo(toolbar, { opacity: 0 }, { opacity: 1, duration:.2 });
    }
    function hideToolbar(target) {
        const image = target.querySelector('img');
        image.classList.remove('blurImage')
        const toolbar = target.querySelector('.hiddenToolBar');
        gsap.fromTo(toolbar, { opacity: 1 }, {opacity:0, duration:.2})
    }
}

initGLFImageShareReveal()